module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Meisterschwanden-0b9109431f14613ac38ee714df68056a.svg";